import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import useRefreshToken from "../hooks/useRefreshToken";
import useAuth from "../hooks/useAuth";

const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const refresh = useRefreshToken();
  const { auth } = useAuth();

  useEffect(() => {
    
    const verifyRefreshToken = async () => {
      try {
        await refresh();
      } catch (err) {
        console.error("Error al refrescar token:", err);
      } finally {
        setIsLoading(false);
      }
    };

    // si no hay accessToken en memoria, intento refrescar
    !auth?.accessToken ? verifyRefreshToken() : setIsLoading(false);

  }, [auth?.accessToken, refresh]);

  return (
    <>
      {isLoading
        ? <p>Cargando sesión...</p>
        : <Outlet />}
    </>
  );
};

export default PersistLogin;
